import { CMM_FILE_EXTENSIONS } from '../../services/cmm-import/importCmmFiles.ts';
import { CmmConfig, ProtocolFinal, RecordDraft } from '../../types/sharedTypeImpl.ts';
import { FileInputButton } from '../fileInputButton.tsx';
import { CmmFilesDialog } from './cmmFilesDialog.tsx';
import { CmmPositionsDialog } from './cmmPositionsDialog.tsx';
import { MultiPartImportDialog } from './multiPartImportDialog.tsx';
import { useCmmImport } from './useCmmImport.tsx';

interface Props {
    style?: React.CSSProperties;
    protocol: ProtocolFinal;
    record: RecordDraft;
    partIndex: number;
    cmmConfigs: CmmConfig[] | undefined;
    setRecord: (record: RecordDraft) => void;
    setIsDirty: (isDirty: boolean) => void;
}

export function CmmImportButtons({ style, protocol, record, partIndex, cmmConfigs, setRecord, setIsDirty }: Props) {
    const {
        filesDialogState,
        positionsDialogState,
        multiPartDialogState,
        isAutoImportClicked,
        isManualImportClicked,
        handleAutoImportClick,
        handleManualImportClick,
        handleLocalFilesSelected,
        handleFilesDialogSubmit,
        handleFilesDialogCancel,
        handlePositionsDialogSubmit,
        handlePositionsDialogCancel,
        handleMultiPartSubmit,
        handleMultiPartCancel,
    } = useCmmImport({
        protocol,
        record,
        partIndex,
        cmmConfigs,
        setRecord,
        setIsDirty,
    });

    return (
        <>
            <div className='button-bar' style={{ ...style }}>
                {record.measurementType === 'production' && (
                    <button type='button' onClick={handleAutoImportClick} disabled={isAutoImportClicked} children='Auto-import' />
                )}
                <button type='button' onClick={handleManualImportClick} disabled={isManualImportClicked} children='Manual import' />
                <FileInputButton
                    allowedExtensions={CMM_FILE_EXTENSIONS}
                    multiple
                    onFilesSelected={handleLocalFilesSelected}
                    content='Local file import'
                />
            </div>

            {filesDialogState && (
                <CmmFilesDialog
                    isOpen={true}
                    cmmReports={filesDialogState.cmmReports}
                    initialFilter={filesDialogState.initialFilter}
                    onCancel={handleFilesDialogCancel}
                    onSubmit={handleFilesDialogSubmit}
                />
            )}
            {positionsDialogState && (
                <CmmPositionsDialog
                    isOpen={true}
                    importResult={positionsDialogState}
                    onCancel={handlePositionsDialogCancel}
                    onSubmit={handlePositionsDialogSubmit}
                />
            )}
            {multiPartDialogState && (
                <MultiPartImportDialog
                    isOpen={true}
                    filename={multiPartDialogState.filename}
                    protocol={protocol}
                    partGroups={multiPartDialogState.partGroups}
                    record={record}
                    currentPartIndex={partIndex}
                    onCancel={handleMultiPartCancel}
                    onSubmit={handleMultiPartSubmit}
                />
            )}
        </>
    );
}
